(function() {

  const filterReset = document.querySelector('#post-filters-reset')


  function getSelectedFacetCount () {
    let selectedFacetCount = 0

    Object.values(FWP.facets).forEach((facet) => {
      selectedFacetCount += facet.length
    })

    return selectedFacetCount
  }

  function showHideResetButton () {
    const selectedFacetCount = getSelectedFacetCount()

    if (selectedFacetCount > 0) {
      filterReset.style.display = 'flex'
    }

    else {
      filterReset.style.display = 'none'
    }
  }


  filterReset.addEventListener('click', (e) => {
    e.preventDefault()
    FWP.reset()
  })

  document.addEventListener('facetwp-refresh', showHideResetButton)

})()